// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2aqZZ","legacyBtn":"MutateMid_legacyBtn__2G_ww"};